import * as React from 'react';
import { useEffect, useState } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { VisuallyHidden } from '@coursera/cds-core';

import FeedbackComplete from 'bundles/content-feedback/components/FeedbackComplete';

type Props = {
  show: boolean;
  message: string;
  onCancel: () => void;
};

const FlagContentNotification: React.FC<Props> = ({ show, message, onCancel }) => {
  // The focus moving when closing the report modal can conflict with the aria-live announcement of the notification so we introduce a slight delay of the announcement
  const [delayedShow, setDelayedShow] = useState(show);

  useEffect(() => {
    const id = setTimeout(() => {
      setDelayedShow(show);
    }, 2000);
    return () => clearTimeout(id);
  }, [show, setDelayedShow]);

  return (
    <>
      <VisuallyHidden role="status">
        {delayedShow && message != null && <div data-testid="aria-live-message">{message}</div>}
      </VisuallyHidden>
      <CSSTransitionGroup transitionName="fade" transitionEnterTimeout={500} transitionLeaveTimeout={500}>
        {show && (
          <FeedbackComplete key="message" onTimeout={onCancel}>
            {message}
          </FeedbackComplete>
        )}
      </CSSTransitionGroup>
    </>
  );
};

export default FlagContentNotification;
